import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { getCommandTypeLabel } from "../commandUtils.js";

const TYPE_ICONS = {
  can: Ico.chip,
  "device-pin": Ico.device,
  custom: Ico.terminal,
};

export function AssetCommandCard({ command, onClick }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const typeLabel = getCommandTypeLabel(command.commandType);
  const typeIcon = TYPE_ICONS[command.commandType] ?? Ico.commands;

  return (
    <button
      type="button"
      onClick={() => onClick(command)}
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "8px 10px",
        borderRadius: 8,
        border: `1px solid ${c.cardBdr}`,
        background: c.card,
        minWidth: 0,
        cursor: "pointer",
        textAlign: "left",
        fontFamily: "inherit",
        transition: "border-color 0.15s ease, background 0.15s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = `${A}44`;
        e.currentTarget.style.background = dark ? `${A}08` : `${A}04`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = c.cardBdr;
        e.currentTarget.style.background = c.card;
      }}
    >
      <span
        style={{
          width: 28,
          height: 28,
          borderRadius: 7,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: A,
          background: dark ? `${A}18` : `${A}10`,
        }}
      >
        {typeIcon}
      </span>

      <span style={{ flex: 1, minWidth: 0, display: "flex", alignItems: "baseline", gap: 6, overflow: "hidden" }}>
        <span
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: c.text,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {command.name}
        </span>
        <span style={{ fontSize: 11, color: c.sub, flexShrink: 0 }}>·</span>
        <span
          style={{
            fontSize: 11,
            color: c.sub,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {typeLabel}
        </span>
      </span>
    </button>
  );
}
